import { useParams, Link } from 'react-router-dom'
import { useLearnerMessageDetail } from '@/features/messages/hooks/useMessages'
import { format } from 'date-fns'
import { ko } from 'date-fns/locale'

export default function LearnerMessageDetailPage() {
  const { id } = useParams<{ id: string }>()
  const { data: message, isLoading } = useLearnerMessageDetail(Number(id))

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    )
  }

  if (!message) {
    return (
      <div className="max-w-3xl mx-auto p-6">
        <div className="text-center py-12 text-gray-500">
          메시지를 찾을 수 없습니다
        </div>
      </div>
    )
  }

  return (
    <div className="max-w-3xl mx-auto p-6">
      <Link
        to="/messages"
        className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 mb-6"
      >
        <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        목록으로
      </Link>

      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h1 className="text-xl font-bold mb-2">{message.title}</h1>
        <div className="flex items-center gap-4 text-sm text-gray-500 mb-6">
          <span>{message.senderName}</span>
          <span>•</span>
          <span>
            {format(new Date(message.createdAt), 'yyyy년 M월 d일 HH:mm', { locale: ko })}
          </span>
        </div>
        <div className="prose prose-sm max-w-none whitespace-pre-wrap">
          {message.content}
        </div>
      </div>
    </div>
  )
}
